// src/i18n/es/hmis.js
const hmis = {
    name: 'Dispositivo HMI |||| Dispositivos HMI',

    list: 'Dispositivos HMI',
    create: 'Crear Nuevo HMI',
    edit: 'Editar HMI',
    show: 'Detalles del HMI',
    details: 'Ver detalles',

    sections: {
        create: 'Nuevo HMI',
        edit: 'Modificar HMI'
    },

    titles: {
        list: 'Dispositivos HMI',
        create: 'Crear Nuevo HMI',
        edit: 'Editar HMI',
        show: 'Detalles del HMI'
    },

    fields: {
        name: 'Nombre del Dispositivo',
        device_id: 'ID del Dispositivo',
        deviceId: 'ID del Dispositivo',
        type: 'Tipo',
        zone: 'Zona',
        hotel: 'Hotel',
        status: 'Estado',
        last_seen: 'Última Conexión',
        lastSeen: 'Última Conexión',
        lastSeenAt: 'Última Conexión',
        controller_address: 'Dirección del Controlador',
        controllerIpAddress: 'IP del Controlador',
        controllerTcpPort: 'Puerto TCP',
        isActive: 'Activo',
        isOnline: 'En línea',
        createdAt: 'Fecha de creación',
        updatedAt: 'Última actualización',
        provisioning_code: 'Código de aprovisionamiento',
        provisioningCode: 'Código de aprovisionamiento',
        expires_at: 'Expira el',
        provisioningCodeExpiresAt: 'Código expira el',
        hasProvisioningCode: 'Tiene código de aprovisionamiento',
        initialApiKey: 'Clave API inicial',
        initial_api_key_available: 'API Key disponible en creación'
    },

    types: {
        tablet: 'Tablet',
        kiosk: 'Kiosk',
        unknown: 'Desconocido'
    },

    status: {
        online: 'En línea',
        offline: 'Desconectado',
        disconnected: 'Desconectado',
        never_connected: 'Nunca conectado',
        active: 'Activo',
        inactive: 'Inactivo',
        expired: 'Expirado',
        no_code: 'Sin código',
        code_active: 'Código Activo',
        code_expired: 'Código Expirado',
        just_now: 'Hace un momento',
        minutes_ago: 'Hace %{minutes} min',
        hours_ago: 'Hace %{hours} h',
        never: 'Nunca'
    },

    actions: {
        create: 'Crear HMI',
        edit: 'Editar',
        delete: 'Eliminar',
        view: 'Ver detalles',
        show: 'Ver detalles',
        generate_provisioning_code: 'Generar Código',
        generate_code: 'Generar Código de Aprovisionamiento',
        configure: 'Configurar',
        refresh: 'Actualizar Estado',
        copy_code: 'Copiar Código',
        reset_api_key: 'Resetear Clave API',
        provision: 'Aprovisionar'
    },

    search: {
        placeholder: 'Buscar...',
        zone_placeholder: 'Buscar por zona...',
        device_placeholder: 'Buscar dispositivos HMI...'
    },

    labels: {
        security_config: 'Configuración de Seguridad',
        device_info: 'Información del Dispositivo',
        provisioning_status: 'Estado de Aprovisionamiento',
        network_config: 'Configuración de Red'
    },

    filters: {
        zone: 'Zona',
        type: 'Tipo',
        status: 'Estado',
        all_zones: 'Todas las zonas',
        all_types: 'Todos los tipos',
        all_statuses: 'Todos los estados',
        search: 'Buscar'
    },

    dialogs: {
        delete: {
            title: 'Eliminar HMI',
            content: '¿Estás seguro de que deseas eliminar este dispositivo HMI?',
            confirm: 'Eliminar',
            cancel: 'Cancelar'
        },
        generate_provisioning_code: {
            title: 'Generar Código de aprovisionamiento',
            content: 'Se generará un nuevo código de aprovisionamiento para este dispositivo.',
            confirm: 'Generar',
            cancel: 'Cancelar'
        },
        provisioning_confirmation: {
            title: 'Confirmar Generación de Código',
            warning: 'Esta acción generará un nuevo código de aprovisionamiento y anulará cualquier código anterior que no se haya utilizado.',
            question: '¿Estás seguro de que deseas continuar?',
            cancel: 'Cancelar',
            confirm: 'Generar Código'
        },
        provisioning_code: {
            title: 'Código de aprovisionamiento',
            label: 'Código de aprovisionamiento',
            expires: 'Este código expira el: %{date}',
            regenerate: 'Regenerar',
            close: 'Cerrar',
            error: 'No se pudo generar el código de aprovisionamiento'
        }
    },

    messages: {
        no_permission_create: 'Solo los SuperAdmins pueden crear nuevos HMIs',
        creation_success: 'HMI creado correctamente',
        create_success_with_key: 'HMI creado correctamente',
        update_success: 'HMI actualizado correctamente',
        delete_success: 'HMI eliminado correctamente',
        code_generated: 'Código de aprovisionamiento generado correctamente',
        code_copied: 'Código copiado al portapapeles',
        loading: 'Cargando...',
        no_data: 'No hay dispositivos HMI disponibles',
        security_superadmin_only: 'Solo los SuperAdmins pueden gestionar la configuración de seguridad.'
    },

    warnings: {
        code_expiration: 'Este código expirará en 30 minutos. Úsalo inmediatamente para aprovisionar el dispositivo.',
        unsaved_changes: 'Tienes cambios sin guardar. ¿Estás seguro de que quieres salir?',
        code_expired_regenerate: 'El código de aprovisionamiento ha expirado. Genera uno nuevo para permitir la configuración del dispositivo.',
        delete_warning: 'Esta acción no se puede deshacer.'
    },

    errors: {
        code_generation_failed: 'Error al generar el código de aprovisionamiento',
        creation_failed: 'Error al crear el HMI',
        update_failed: 'Error al actualizar el HMI',
        delete_failed: 'Error al eliminar el HMI',
        load_failed: 'Error al cargar los datos',
        permission_denied: 'No tienes permisos para realizar esta acción'
    },

    help: {
        provisioning_instructions: 'Usa este código en el dispositivo HMI para completar el proceso de aprovisionamiento. El código expira en 30 minutos.',
        device_id_help: 'Identificador único del dispositivo (3-50 caracteres, solo letras, números, guiones y guiones bajos)',
        name_help: 'Nombre descriptivo del dispositivo (2-100 caracteres)'
    },

    validation: {
        name_required: 'El nombre del dispositivo es obligatorio',
        name_min_length: 'El nombre debe tener al menos 2 caracteres',
        name_max_length: 'El nombre no puede tener más de 100 caracteres',
        device_id_required: 'El ID del dispositivo es obligatorio',
        device_id_invalid: 'El ID del dispositivo debe tener 3-50 caracteres y solo contener letras, números, guiones y guiones bajos',
        type_required: 'El tipo de dispositivo es obligatorio',
        zone_required: 'La zona es obligatoria',
        hotel_required: 'El hotel es obligatorio'
    },

    ui: {
        device_information: 'Información del Dispositivo',
        security_configuration: 'Configuración de Seguridad',
        connection_status: 'Estado de conexión',
        last_connection: 'Última conexión',
        device_type: 'Tipo de dispositivo',
        provisioning_status: 'Estado de aprovisionamiento',
        api_management: 'Gestión de API',
        refresh_status: 'Actualizar estado'
    },

    notifications: {
        provisioning_code_generated: 'Código de aprovisionamiento generado con éxito',
        provisioning_code_error: 'Error al generar el código de aprovisionamiento',
        code_copied: 'Código copiado al portapapeles'
    }
};

export default hmis;
